export enum NANNY_ADMIN {
    /**
     * @value Add rule
     * @description Action to create a rule
     */
    ADD_RULE = 'ADMIN.NANNY.ADD_RULE',
    /**
     * @value Sensitive data flagging rules do not apply yet to the following features:
     * <ul>
     *     <li>
     *         <strong>Article</strong>, nor related comments
     *     </li>
     *     <li>
     *         <strong>Event</strong>, nor related comments
     *     </li>
     * </ul>
     * @description Message displayed to list the features where data flagging will be applied.
     */
    COMPATIBILITY_MESSAGE = 'NANNY_ADMIN.COMPATIBILITY_MESSAGE',
    /**
     * @value This action is permanent, the rule %RULE% will no longer be verified by the system.
     * @description Confirm text when deleting a rule. The %RULE% will be replaced by the rule title
     *
     * Parameters:
     * - RULE: rule title
     */
    DELETE_EXPLANATION = 'ADMIN.NANNY.DELETE_EXPLANATION',
    /**
     * @value Delete the sensitive data rule?
     * @description Modal title when deleting a rule
     */
    DELETE_TITLE = 'ADMIN.NANNY.DELETE_TITLE',
    /**
     * @value Enable publishing with report
     * @description Checkbox label to allow publication when the sensitive data rule is trigerred (turn the rule into an optional rule)
     */
    ENABLE_PUBLISHING_WITH_VIOLATION = 'NANNY.ENABLE_PUBLISHING_WITH_VIOLATION',
    /**
     * @value If this setting is enabled, users can publish content triggering the rule. Such content will be reported to admins for verification.
     * @description helper for the checkbox: "Allow publication with report to moderation" that allow publication when the sensitive data rule is trigerred (turn the rule into an optional rule)
     */
    ENABLE_PUBLISHING_WITH_VIOLATION_HELPER = 'NANNY.ENABLE_PUBLISHING_WITH_VIOLATION_HELPER',
    /**
     * @value Language concerned
     * @description The language concerned for a Rule
     */
    FORM_LANGUAGE_CONCERNED = 'ADMIN.NANNY.FORM_LANGUAGE_CONCERNED_SECTION',
    /**
     * @value New sensitive data rule
     * @description Title for the new form
     */
    FORM_NEW_TITLE = 'ADMIN.NANNY.FORM_NEW_TITLE',
    /**
     * @value Definition
     * @description Title of the Definition section
     */
    FORM_RULE_DEFINITION = 'ADMIN.NANNY.FORM_RULE_DEFINITION_SECTION',
    /**
     * @value Explanation in %LANG%
     * @description Rule explanation field title
     *
     * Parameters:
     * - LANG: lang to use to explain the rule
     */
    FORM_RULE_EXPLANATION = 'ADMIN.NANNY.FORM_RULE_EXPLANATION',
    /**
     * @value Users will see this explanation if they try to use matching data.
     * @description Rule explanation helper
     */
    FORM_RULE_EXPLANATION_HELPER = 'ADMIN.NANNY.FORM_RULE_EXPLANATION_HELPER',
    /**
     * @value File
     * @description Rule file type
     */
    FORM_RULE_FILE = 'ADMIN.NANNY.FORM_RULE_FILE',
    /**
     * @value Regular expression
     * @description Rule content (regexp) field name
     */
    FORM_RULE_REGEXP = 'ADMIN.NANNY.FORM_RULE_REGEXP',
    /**
     * @value Ex: (^|[\s{S}]|[^\w\s/]+)([0-9]{11}|[0-9]{12}|[0-9]{14})([\p{P}\s{S}]|$) for bank accounts numbers
     * @description Rule regexp field information helper
     */
    FORM_RULE_REGEXP_HELPER = 'ADMIN.NANNY.FORM_RULE_REGEXP_HELPER',
    /**
     * @value Enter an expression
     * @description Rule regexp field placeholder
     */
    FORM_RULE_REGEXP_PLACEHOLDER = 'ADMIN.NANNY.FORM_RULE_REGEXP_PLACEHOLDER',
    FORM_RULE_TITLE = 'ADMIN.NANNY.FORM_RULE_TITLE',
    /**
     * @value Update the sensitive data rule
     * @description Title of the modal used for updating a rule
     */
    FORM_UPDATE_TITLE = 'ADMIN.NANNY.FORM_UPDATE_TITLE',
    /**
     * @value Language(s)
     * @description The language field
     */
    LANGUAGE = 'ADMIN.NANNY.LANGUAGE',
    /**
     * @value Last update
     * @description Sensitive data rule last update info
     */
    LAST_UPDATE = 'ADMIN.NANNY.LAST_UPDATE',
    /**
     * @value You have reached the maximum of %NB% entries allowed
     * @description The message displayed to the user when the number of rules has reached the limit
     *
     * Parameters:
     * - NB: number of entries
     */
    MAX_RULES_REACHED = 'ADMIN.NANNY.MAX_RULES_REACHED',
    /**
     * @value Sensitive data flagging
     * @description Title of the Nanny feature
     */
    SENSITIVE_DATA_FLAGGING = 'ADMIN.NANNY.SENSITIVE_DATA',
    /**
     * @value Use CSV file with either semicolon or end of line as a delimiter between words
     * @description Description of the upload field
     */
    UPLOAD_FILE_DESC = 'ADMIN.NANNY.UPLOAD_FILE_DESC',
    /**
     * @value Violation count
     * @description Number of time that a sensitive data rule has been called
     */
    VIOLATION_COUNT = 'ADMIN.NANNY.VIOLATION_COUNT',
}
